import React, { useState } from 'react';
import '../styles/Pages.css';
import { useEffect } from "react";

const EMAILJS_SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID || 'YOUR_EMAILJS_SERVICE_ID';
const EMAILJS_TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID || 'YOUR_EMAILJS_TEMPLATE_ID';
const EMAILJS_PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY || 'YOUR_EMAILJS_PUBLIC_KEY';
const EMAILJS_TO_EMAIL = 'info@datamaticsconsulting.com';
const MAX_MESSAGE_LENGTH = 180;

function Contact() {
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        company: '',
        phone: '',
        message: '',
    });
    const [statusMessage, setStatusMessage] = useState('');
    const [isSending, setIsSending] = useState(false);
    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === 'message' && value.length > MAX_MESSAGE_LENGTH) return;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const sendEmail = async () => {
        if (EMAILJS_SERVICE_ID.includes('YOUR_') ||
            EMAILJS_TEMPLATE_ID.includes('YOUR_') ||
            EMAILJS_PUBLIC_KEY.includes('YOUR_')) {
            throw new Error('EmailJS is not configured.');
        }

        const templateParams = {
            first_name: formData.firstName,
            last_name: formData.lastName,
            from_email: formData.email,
            company: formData.company,
            phone: formData.phone,
            message: formData.message,
            subject: `Contact form submission from ${formData.firstName} ${formData.lastName}`,
            to_email: EMAILJS_TO_EMAIL,
        };

        const response = await fetch('https://api.emailjs.com/api/v1.0/email/send', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                service_id: EMAILJS_SERVICE_ID,
                template_id: EMAILJS_TEMPLATE_ID,
                user_id: EMAILJS_PUBLIC_KEY,
                template_params: templateParams,
            }),
        });

        if (!response.ok) throw new Error('Failed to send message');
    };

    const resetForm = () => {
        setFormData({ firstName: '', lastName: '', email: '', company: '', phone: '', message: '' });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatusMessage('');
        setIsSending(true);

        try {
            await sendEmail();
            setStatusMessage('Message sent successfully — we will be in touch soon!');
            resetForm();
        } catch (error) {
            setStatusMessage('Failed to send message. Please try again.');
        } finally {
            setIsSending(false);
        }
    };

    useEffect(() => {
        document.title = "Contact Us | Datamatics Consulting";
    }, []);

    return (
        <section className="contact-page">
            <div className="contact-grid">
                {/* Left Side - Text */}
                <div className="contact-left">
                    <div className="lets-connect">
                        <span className="section-tag">
                            <span className="tag-line"></span> Let's Connect
                        </span>
                        <h1>Every Connection<br />Begins with a<br />Conversations.</h1>
                    </div>
                </div>
                {/* Right Side - Form */}
                <div className="contact-right">
                    <h2 className="inquire-heading">Inquire Here</h2>
                    <div className="contact-form-card">
                        <form className="contact-form" onSubmit={handleSubmit}>
                            <div className="form-row-two">
                                <input
                                    type="text"
                                    name="firstName"
                                    placeholder="First Name *"
                                    value={formData.firstName}
                                    onChange={handleChange}
                                    required
                                />
                                <input
                                    type="text"
                                    name="lastName"
                                    placeholder="Last Name *"
                                    value={formData.lastName}
                                    onChange={handleChange}
                                    required
                                />
                            </div>

                            <div className="form-row-two">
                                <input
                                    type="email"
                                    name="email"
                                    placeholder="Email Address *"
                                    value={formData.email}
                                    onChange={handleChange}
                                    required
                                />
                                <input
                                    type="text"
                                    name="company"
                                    placeholder="Company / Organization *"
                                    value={formData.company}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            <input
                                type="tel"
                                name="phone"
                                placeholder="E.g. +1 3004005000"
                                value={formData.phone}
                                onChange={handleChange}
                                required
                            />
                            <div className="textarea-wrapper">
                                <textarea
                                    name="message"
                                    placeholder="Write Here ..."
                                    rows="5"
                                    value={formData.message}
                                    onChange={handleChange}
                                    required
                                />
                                <span className="char-counter">
                                    {formData.message.length} / {MAX_MESSAGE_LENGTH}
                                </span>
                            </div>

                            <button type="submit" className="contact-submit-btn" disabled={isSending}>
                                {isSending ? 'Sending...' : 'Send'}
                            </button>
                        </form>
                        {statusMessage && <p className="form-status-message">{statusMessage}</p>}
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Contact;